import { SERVICE_COLOR_3 } from '../../core/styles/variables';

export const PRIMARY_COLOR = '#0177B4';
export const BACKGROUND_COLOR = SERVICE_COLOR_3;
export const DIVIDER_COLOR = '#7FBAD9';
export const EXPAND_ICON_COLOR = '#3077AF';
export const EXPAND_BACKGROUND_COLOR = '#EFF9FD';

export const CREDIT = '写真提供：佐賀県観光連盟';
